import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import Progress from '../progress';

import { Step1ReviewSession } from './step1';
import { Step2ReviewSession } from './step2';
import { Step3ReviewSession } from './step3';
import { Step4ReviewSession } from './step4';

import Logo from '../images/logo.jpg';

import './styles.css';

export default function ProcessReviewSession({
  availableGameTypes,
  onSelectGameType,
  selectedGameTypes,
  selectedBusinessType,
  onFinish,
  activeLoadingStep,
  selectedGameTypesMinutes,
  latestTournament,
  isButtonLoading,
}) {
  const location = useLocation();
  const isAllSetPage = location.pathname.endsWith('/all-set');

  const [currentStep, setCurrentStep] = useState(isAllSetPage ? 4 : 1);
  const [isAnimating, setIsAnimating] = useState(false);
  const [animationDirection, setAnimationDirection] = useState('next');

  const handleNextStep = () => {
    if(currentStep < 4 && !isAllSetPage) {
      if (!isAnimating) {
        setAnimationDirection('next');
        setIsAnimating(true);

        setTimeout(() => {
          if(currentStep === 2) {
            onFinish();
          }
          setCurrentStep(currentStep + 1);
          setIsAnimating(false);
        }, 300);
      }
    } else {
      onFinish();
    }
  }

  const handlePrevStep = () => {
    if (currentStep > 1 && !isAnimating) {
      setAnimationDirection('prev');
      setIsAnimating(true);

      setTimeout(() => {
        setCurrentStep(currentStep - 1);
        setIsAnimating(false);
      }, 300);
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <Step1ReviewSession
            onNext={handleNextStep}
          />
        );
      case 2:
        return (
          <Step2ReviewSession
            onNext={handleNextStep}
            onPrev={handlePrevStep}
            availableGameTypes={availableGameTypes}
            onSelectGameType={onSelectGameType}
            selectedGameTypes={selectedGameTypes}
            selectedGameTypesMinutes={selectedGameTypesMinutes}
          />
        );
      case 3:
        return (
          <Step3ReviewSession
            activeLoadingStep={activeLoadingStep}
            availableGameTypes={availableGameTypes}
            selectedGameTypes={selectedGameTypes}
          />
        );
      case 4:
        return (
          <Step4ReviewSession
            activeLoadingStep={activeLoadingStep}
            availableGameTypes={availableGameTypes}
            selectedGameTypes={selectedGameTypes}
            onNext={handleNextStep}
            latestTournament={latestTournament}
            isButtonLoading={isButtonLoading}
          />
        );
      default:
        return <Step1ReviewSession onNext={handleNextStep} />;
    }
  }

  const isProgressVisible = (currentStep > 1 && currentStep < 3) ? true : false;

  return (
    <div className="onboarding-process">
      <div className={`logo-wrapper${currentStep > 1 ? ' visible' : ''}`}>
        <img src={Logo} alt="Logo" className="onboarding-logo" />
        <span>Market Games</span>
      </div>
      <Progress
        currentStep={currentStep}
        totalSteps={3}
        selectedBusinessType={selectedBusinessType}
        isVisible={isProgressVisible}
      />

      <div className={`step-container ${isAnimating ? `animating-${animationDirection}` : ''}`}>
        {renderStep()}
      </div>
    </div>
  )
};
